export default __webpack_public_path__ + "static/media/Dinheiro.e9c02e64.svg";